import React, { useState } from 'react';
import { TextField } from 'components/inputs/TextField';
import { Checkbox } from 'components/inputs/Checkbox';
import { InputLayer } from 'domains/designers/common/InputLayer';
import { IHint, ShortcutHintList } from 'components/ShortcutHintList';
import './NameInputLayer.less';
import classNames from 'classnames';

export interface INameInputLayerProps {
  className?: string;
  onInput: (name: string, isList: boolean) => void;
}

export function NameInputLayer({ className, onInput }: INameInputLayerProps) {
  const [inputName, setInputName] = useState<string>('');
  const [isList, setIsList] = useState<boolean>(false);

  const handleChange = (fieldType: string, e: React.ChangeEvent<HTMLInputElement>) => {
    if (fieldType === 'name') {
      setInputName(e.target.value);
    }
    if (fieldType === 'is-list') {
      setIsList(e.target.checked);
    }
  };

  const closeLayer = () => {
    handleEnterClick();
  };

  const handleEnterClick = () => {
    onInput(inputName, isList);
  };

  const handleShiftEnterClick = () => {
    onInput(inputName, true);
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        handleShiftEnterClick();
      } else {
        handleEnterClick();
      }
    } else if (e.key === 'Escape') {
      closeLayer();
    }
  };

  const shortCuts: IHint[] = [
    {
      keyValue: 'Enter',
      label: 'Save',
      onClick: handleEnterClick,
    },
    {
      keyValue: 'Shift + Enter',
      label: 'Save and make a list',
      onClick: handleShiftEnterClick,
    },
  ];

  return (
    <InputLayer
      className={classNames('dp-name-input-layer', className)}
      onKeyUp={handleKeyUp}
      onClickOutside={closeLayer}
    >
      <div className="dp-name-input-layer__content">
        <TextField
          placeholder="Set Input Name"
          className="dp-name-input-layer__input-name"
          aria-label="Set Input Name"
          onChange={handleChange.bind(null, 'name')}
          value={inputName}
        />
        <Checkbox
          id="is-list"
          checked={isList}
          className="dp-name-input-layer__input-is-list"
          label="Is List"
          onChange={handleChange.bind(null, 'is-list')}
        />
      </div>
      <ShortcutHintList hints={shortCuts} />
    </InputLayer>
  );
}
